module.exports = __webpack_public_path__ + "img/ININAL.7f0387f4.png";